<div class="component-viewer">
    <h1>Edit Iteration</h1>
    <mat-card *ngIf="selectedIteration">
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Start Date</mat-label>
                                <input matInput required name="startDate" id="startDate" placeholder="Start Date"
                                    type="text" formControlName="startDate" />
                                <mat-error *ngIf="form.get('startDate').errors?.required">Start Date is required
                                </mat-error>
                                <mat-error *ngIf="form.get('startDate').errors?.validationErrors">
                                    {{ form.get("startDate").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Registration Code</mat-label>
                                <input required matInput name="registrationCode" id="registrationCode"
                                    placeholder="Registration Code" type="text" formControlName="registrationCode" />
                                <mat-error *ngIf="form.get('registrationCode').errors?.required">Registration Code is
                                    required
                                </mat-error>
                                <mat-error *ngIf="form.get('registrationCode').errors?.validationErrors">
                                    {{ form.get("registrationCode").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Cost</mat-label>
                                <input required matInput name="cost" id="cost" placeholder="Cost" type="number"
                                    formControlName="cost" />
                                <mat-icon matPrefix style="vertical-align: middle;">attach_money</mat-icon>
                                <mat-error *ngIf="form.get('cost').errors?.required">Cost is required
                                </mat-error>
                                <mat-error *ngIf="form.get('cost').errors?.validationErrors">
                                    {{ form.get("cost").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Credit Card Fee</mat-label>
                                <input matInput name="creditCardFee" id="creditCardFee" placeholder="Credit Card Fee"
                                    type="number" formControlName="creditCardFee" />
                                <mat-icon matPrefix style="vertical-align: middle;">attach_money</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1">
                        <button mat-raised-button [disabled]="!canEditIteration">Save</button>
                    </div>
                    <div class="col-1">
                        <button mat-raised-button color="warn" [routerLink]="['/outing-management/administration/outing', 'iterations']">Cancel</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <div *ngIf="!canEditIteration" class="alert alert-warning mt-3">
        <mat-icon>warning</mat-icon>
        <span>This iteration cannot be edited because the start date has already passed.</span>
    </div>
</div>